import React from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'
import HomeBanner from '../components/HomeBanner/HomeBanner'
import PopularProfessional from '../components/popularProfessional/PopularProfessional'
import ConsumerSay from '../components/ConsumerSays/ConsumerSay'
import PopularProfessionalOpenSearch from '../components/popularProfessional/PopularProfessionalOpenSearch'

const Home = () => {
    return (
        <>
            <SecondHeader />
            <HomeBanner />
            {/* <PopularProfessional /> */}
            <PopularProfessionalOpenSearch />

            <ConsumerSay />
            <Footer />
        </>
    )
}

export default Home